class SellingForm {
  constructor() {
    this.itemCount = 1;
    
    this.init();
  }

  init() {
    this.initTableFunctionality();
    this.initPriceCalculation();
  }

  initTableFunctionality() {
    const addButton = document.getElementById('add-item-row');
    const itemsContainer = document.getElementById('items-container');

    if (addButton && itemsContainer) {
      addButton.addEventListener('click', () => this.addItem());
      
      itemsContainer.addEventListener('click', (e) => {
        if (e.target.classList.contains('selling-form__remove-item') || 
            e.target.closest('.selling-form__remove-item')) {
          this.removeItem(e.target.closest('.selling-form__item'));
        }
        
        if (e.target.classList.contains('selling-form__item-toggle') || 
            e.target.closest('.selling-form__item-toggle')) {
          this.toggleItem(e.target.closest('.selling-form__item'));
        }
      });
    }
  }

  toggleItem(item) {
    const toggle = item.querySelector('.selling-form__item-toggle');
    const fields = item.querySelector('.selling-form__item-fields');
    const arrow = item.querySelector('.selling-form__item-arrow');
    const isExpanded = toggle.getAttribute('aria-expanded') === 'true';
    
    toggle.setAttribute('aria-expanded', !isExpanded);
    fields.style.display = isExpanded ? 'none' : 'block';
    arrow.style.transform = isExpanded ? 'rotate(-90deg)' : 'rotate(0deg)';
  }

  addItem() {
    const allItems = document.querySelectorAll('.selling-form__item');
    allItems.forEach(item => {
      const toggle = item.querySelector('.selling-form__item-toggle');
      const fields = item.querySelector('.selling-form__item-fields');
      const arrow = item.querySelector('.selling-form__item-arrow');
      
      toggle.setAttribute('aria-expanded', 'false');
      fields.style.display = 'none';
      arrow.style.transform = 'rotate(-90deg)';
    });

    this.itemCount++;
    const itemsContainer = document.getElementById('items-container');
    const newItem = document.createElement('div');
    newItem.classList.add('selling-form__item');
    newItem.setAttribute('data-item-number', this.itemCount);
    
    newItem.innerHTML = `
      <div class="selling-form__item-header">
        <button type="button" class="selling-form__item-toggle" aria-expanded="true" aria-label="Toggle item details">
          <svg class="selling-form__item-arrow" width="20" height="20" viewBox="0 0 20 20" fill="none">
            <path d="M5 7.5L10 12.5L15 7.5" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
          <h4 class="selling-form__item-title">Item ${this.itemCount}</h4>
        </button>
        <button type="button" class="selling-form__remove-item" aria-label="Remove item">× Remove</button>
      </div>
      
      <div class="selling-form__item-fields" style="display: block;">
        <div class="field">
          <input
            class="field__input"
            type="text"
            id="SellingForm-item-${this.itemCount}-brand"
            name="contact[Item ${this.itemCount} Brand]"
            placeholder="Brand"
            required
          >
          <label class="field__label" for="SellingForm-item-${this.itemCount}-brand">Brand <span aria-hidden="true">*</span></label>
        </div>

        <div class="contact__fields">
          <div class="field">
            <input
              class="field__input"
              type="text"
              id="SellingForm-item-${this.itemCount}-garment"
              name="contact[Item ${this.itemCount} Garment]"
              placeholder="Garment"
              required
            >
            <label class="field__label" for="SellingForm-item-${this.itemCount}-garment">Garment <span aria-hidden="true">*</span></label>
          </div>

          <div class="field">
            <input
              class="field__input"
              type="text"
              id="SellingForm-item-${this.itemCount}-size"
              name="contact[Item ${this.itemCount} Size]"
              placeholder="Size"
              required
            >
            <label class="field__label" for="SellingForm-item-${this.itemCount}-size">Size <span aria-hidden="true">*</span></label>
          </div>
        </div>

        <div class="contact__fields">
          <div class="field">
            <input
              class="field__input selling-form__price-input"
              type="text"
              id="SellingForm-item-${this.itemCount}-price"
              name="contact[Item ${this.itemCount} Estimated Price]"
              placeholder="$0.00"
              required
            >
            <label class="field__label" for="SellingForm-item-${this.itemCount}-price">Estimated Re-Sale Price <span aria-hidden="true">*</span></label>
          </div>

          <div class="field">
            <input
              class="field__input selling-form__payout-input"
              type="text"
              id="SellingForm-item-${this.itemCount}-payout"
              name="contact[Item ${this.itemCount} Payout]"
              placeholder="$0.00"
              readonly
            >
            <label class="field__label" for="SellingForm-item-${this.itemCount}-payout">Your Payout (30% of Re-Sale value)</label>
          </div>
        </div>

        <div class="field">
          <input
            class="field__input"
            type="url"
            id="SellingForm-item-${this.itemCount}-photo"
            name="contact[Item ${this.itemCount} Photo Link]"
            placeholder="https://drive.google.com/... or https://dropbox.com/..."
          >
          <label class="field__label" for="SellingForm-item-${this.itemCount}-photo">Photo Link (Google Drive/Dropbox)</label>
        </div>
        <small class="selling-form__help-text">Please provide a link to 4-8 photos of this item. If no link provided, please send 4 photos of the item to contact@luxeloop.co.nz</small>
      </div>
    `;
    
    itemsContainer.appendChild(newItem);
    
    const priceInput = newItem.querySelector('.selling-form__price-input');
    if (priceInput) {
      priceInput.addEventListener('input', (e) => this.calculatePayout(e.target));
    }
  }

  removeItem(item) {
    const itemsContainer = document.getElementById('items-container');
    if (itemsContainer.children.length > 1) {
      item.remove();
    } else {
      alert('You must have at least one item.');
    }
  }

  initPriceCalculation() {
    const priceInputs = document.querySelectorAll('.selling-form__price-input');
    priceInputs.forEach(input => {
      input.addEventListener('input', (e) => this.calculatePayout(e.target));
    });
  }

  calculatePayout(priceInput) {
    const item = priceInput.closest('.selling-form__item') || priceInput.closest('.selling-form__item-fields');
    const payoutInput = item.querySelector('.selling-form__payout-input');
    
    let priceValue = priceInput.value.replace(/[^0-9.]/g, '');
    const price = parseFloat(priceValue) || 0;
    const payout = (price * 0.30).toFixed(2);
    
    payoutInput.value = price > 0 ? `$${payout}` : '';
    
    if (priceValue && !priceInput.value.startsWith('$')) {
      priceInput.value = `$${priceValue}`;
    }
  }
}

if (document.getElementById('SellingForm')) {
  new SellingForm();
}
